import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'crg-viewreservations',
  templateUrl: './viewreservations.component.html',
  styleUrls: ['./viewreservations.component.scss']
})
export class ViewreservationsComponent implements OnInit {
  constructor() { }

  ngOnInit() {
  }
}
